export const EVENT_BADGE = {
  DOUBLE_ELEVEN: ['雙 1 1'],
}
